import { NavLink } from "react-router-dom";
import React, { useContext } from "react";
import { AccountContext } from "../../User/Account";

export const Navbar = () => {
	const { isAuthenticated, getSession, logout } = useContext(AccountContext);

	return (
		<nav className="navbar navbar-expand-lg main-color py-3 custom">
			<div className="container-fluid">
				<span className="navbar-brand text-danger">
					<div className="logo"></div>
				</span>
				<button
					className="navbar-toggler"
					style={{ outline: "none", boxShadow: "none" }}
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarNavDropdown"
					aria-controls="navbarNavDropdown"
					aria-expanded="false"
					aria-label="Toggle Navigation"
				>
					<span
						className="navbar-toggler-icon btn-lightred white-outline"
						style={{ width: "40px", height: "40px" }}
					></span>
				</button>
				<div
					className="collapse navbar-collapse"
					id="navbarNavDropdown"
				>
					<ul className="navbar-nav ">
						<li className="nav-item">
							<NavLink
								className="nav-link text-danger hover-menu"
								style={{ paddingLeft: "50px" }}
								to="/"
							>
								Home
							</NavLink>
						</li>
						<li className="nav-item">
							<NavLink
								className="nav-link text-danger hover-menu"
								style={{ paddingLeft: "50px" }}
								to="/search"
							>
								Search Comics
							</NavLink>
						</li>

						<li className="nav-item">
							<NavLink
								className="nav-link text-danger hover-menu"
								style={{ paddingLeft: "50px" }}
								to="/special"
							>
								Special
							</NavLink>
						</li>
					</ul>

					<ul
						className="navbar-nav ms-auto"
						style={{ paddingLeft: "50px" }}
					>
						<li className="nav-item m-1">
							{isAuthenticated ? (
								<button onClick={logout}>
									Click here to Logout
								</button>
							) : (
								<NavLink
									activeClassName="activeNavLink"
									type="button"
									className="btn btn-lightred white-outline"
									to="/login"
								>
									Sign in
								</NavLink>
							)}
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
};
